<template>
  <li class="t-list-item" :class="[
    { 't-list-item--inline': inline },
  ]">
    <slot></slot>
  </li>
</template>

<script>
export default {
  name: 't-list-item',
  props: {
    inline: Boolean,
  },
};
</script>
